module.exports = __webpack_public_path__ + "static/img/JM.bb229d19.png";